module.exports = __webpack_public_path__ + "static/media/mountains.d418c80d.jpg";